import React from 'react';
import { Link } from 'react-router-dom';
import { CopyableText } from '@css-xp/base';
import EntitlementIcon from '@css-xp/base/entitlement-icon';
import { EntitlementStatus } from '@css-xp/base/entitlement-utils';
import { BilledExternallyTag } from '@css-xp/ppc-billed-externally';
import '../order-history-table.scss';

export interface CloudProductViewProps {
  testId?: string;
  subscriptionRoute: string;
  productId: string | undefined;
  productName: string | undefined | null;
  entitlementNumber: string;
  logoId?: string;
  isSandbox?: boolean;
  isAddOn?: boolean;
  isExternallyBilled?: boolean;
}

export const CloudProductView = ({
  testId = 'ppc-cloud-product-view',
  subscriptionRoute,
  productId,
  productName,
  logoId,
  entitlementNumber,
  isSandbox,
  isAddOn,
  isExternallyBilled,
}: CloudProductViewProps) => {
  return (
    <div className={'ppc-cloud-product-view'} data-testid={testId}>
      <Link to={subscriptionRoute} onClick={(e) => e.stopPropagation()} className="avatar-container">
        <EntitlementIcon logoId={logoId} productId={productId} isCloud={true} className="avatar medium" />{' '}
        <span data-testid={productId}>{productName ?? 'Unnamed product'}</span>
      </Link>
      <h6 className={'entitlement-number'}>{entitlementNumber && <CopyableText text={entitlementNumber} />}</h6>
      {isExternallyBilled && <BilledExternallyTag marginLeft="32" />}
      {isSandbox && (
        <div className="edition-details">
          <EntitlementStatus isSandbox={isSandbox} />
        </div>
      )}
      {isAddOn && (
        <div className="edition-details">
          <EntitlementStatus isAddOn={isAddOn} />
        </div>
      )}
    </div>
  );
};
